if (
  typeof window !== 'undefined' &&
  typeof HTMLFormElement !== 'undefined' &&
  !HTMLFormElement.prototype.requestSubmit
) {
  HTMLFormElement.prototype.requestSubmit = function (submitter?: HTMLElement) {
    if (submitter) {
      if (!(submitter instanceof HTMLElement)) {
        throw new TypeError("Parameter 1 is not of type 'HTMLElement'.");
      }
      if ((submitter as HTMLButtonElement | HTMLInputElement).type !== 'submit') {
        throw new TypeError('The specified element is not a submit button.');
      }
      if ((submitter as HTMLButtonElement | HTMLInputElement).form !== this) {
        throw new DOMException(
          'The specified element is not owned by this form element.',
          'NotFoundError'
        );
      }
      submitter.click();
      return;
    }
    const btn = document.createElement('input');
    btn.type = 'submit';
    btn.hidden = true;
    this.appendChild(btn);
    btn.click();
    this.removeChild(btn);
  };
}
